import React, {FC} from 'react';
import cn from 'classnames';
import styles from './Checkbox.css';

export type CheckboxProps = Omit<
	React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
	'ref' | 'type'
>;

export const Checkbox: FC<CheckboxProps> = props => {
	const {className, ...proxyProps} = props;
	return <input className={cn(styles.root, className)} type='checkbox' {...proxyProps} />;
};

Checkbox.displayName = 'Checkbox';
